import { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { actualizarProyecto, agregarProducto } from "../../../service/AffariService";
import { useGlobalContext } from "../../../Config";

const TableDetalleCotizacion = ({
    idCotizacion,
    detalles,
    relacionados,
    onUpdateLine,
    onRemoveLine,
    interfaz,
    proyectos,
    proyecto,
    onRefresh,
    onChangeCantidad,
    onNotify,
    confirming,
    almacenes,
    edit,
    setLoading
}) => {
    const { isDinar, isSack } = useGlobalContext();
    const normalizeProyecto = (value) => (value === '0' || value === 0 ? null : value);
    const [proyectoSeleccionado, setProyectoSeleccionado] = useState(normalizeProyecto(proyecto));
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const normalized = normalizeProyecto(proyecto);
        if (proyectoSeleccionado == null && normalized != null) {
            setProyectoSeleccionado(normalized);
        }
    }, [proyecto, proyectoSeleccionado]);

    const handleProyectoChange = (e) => {
        setLoading(true);
        const nuevoProyecto = e.value;
        setProyectoSeleccionado(nuevoProyecto);
        if (idCotizacion && nuevoProyecto) {
            actualizarProyecto(idCotizacion, nuevoProyecto)
                .then(response => {
                    console.log("Proyecto actualizado:", response);
                    if (onRefresh) onRefresh();
                })
                .catch(error => {
                    console.error("Error actualizando proyecto:", error);
                    if (onNotify) onNotify('error', 'Error actualizando proyecto', error.message || '');
                });
        }
    };

    const addRelacionado = async (codigo) => {
        try {
            setLoading(true);
            await agregarProducto(idCotizacion, codigo);
            if (onRefresh) onRefresh();
        } catch (error) {
            console.error('Error agregando producto:', error);
            if (onNotify) onNotify('error', 'Error agregando producto', 'El producto ya fue agregado o no existe.' || error.message);
        }
    };

    const MobileRow = ({ rowData, index }) => (
        <div className="surface-card border-1 surface-border border-round p-3 mb-3">
            <div className="flex justify-content-between align-items-center mb-2">
                <span className="text-500">#{index + 1}</span>
                <Button icon="pi pi-trash" className="p-button-text p-button-danger p-button-sm" onClick={() => onRemoveLine(index)} />
            </div>
            <div className="flex flex-column gap-2">
                <div className="flex flex-column">
                    <span className="text-600 text-sm">Cantidad</span>
                    <InputNumber
                        value={rowData.cantidad}
                        onValueChange={(e) => onChangeCantidad(e.value ?? 0, rowData.id)}
                        inputClassName="p-inputtext-sm text-center"
                        min={0}
                        step={1}
                        minFractionDigits={0}
                        maxFractionDigits={0}
                        placeholder="0"
                        disabled={confirming}
                        showButtons={false}
                    />
                </div>

                <div className="flex justify-content-between">
                    <span className="text-600 text-sm">Artículo</span>
                    <span className="text-900">{rowData.referencia}</span>
                </div>
                
                <div className="flex flex-column">
                    <span className="text-600 text-sm">Descripción</span>
                    <span className="text-900" style={{ whiteSpace: 'normal' }}>{rowData.descripcion}</span>
                </div>

                {interfaz === 'MAYORISTA' ? (
                    <div className="flex flex-column">
                        <span className="text-600 text-sm">Centro</span>
                        <Dropdown
                            value={rowData.centro}
                            options={almacenes || []}
                            optionLabel="sucursal"
                            optionValue="almacen"
                            onChange={(e) => onUpdateLine(index, 'centro', e.value)}
                            className="p-inputtext-sm"
                            disabled={confirming}
                            placeholder="Seleccione centro"
                        />
                    </div>
                ) : (
                    confirming ? (
                        <div className="flex flex-column">
                            <span className="text-600 text-sm">Centro</span>
                            <Dropdown
                                value={rowData.centro}
                                options={almacenes || []}
                                optionLabel="sucursal"
                                optionValue="almacen"
                                onChange={(e) => onUpdateLine(index, 'centro', e.value)}
                                className="p-inputtext-sm"
                                placeholder="Seleccione centro"
                            />
                        </div>
                    ) : null
                )}

                <div className="flex justify-content-between">
                    <span className="text-600 text-sm">Precio Lista</span>
                    <span className="text-900">{Number(rowData.precio_lista ?? 0).toLocaleString('es-CL')}</span>
                </div>

                <div className="flex flex-column">
                    <span className="text-600 text-sm">Precio</span>
                    <InputNumber
                        value={rowData.precio}
                        onValueChange={(e) => onUpdateLine(index, 'precio', e.value)}
                        className="w-full"
                        inputClassName="p-inputtext-sm text-right"
                        min={0}
                        locale="es-CL"
                        useGrouping={false}
                        disabled={confirming}
                    />
                </div>

                <div className="flex flex-column">
                    <span className="text-600 text-sm">Desc</span>
                    <InputNumber
                        value={rowData.descuento}
                        onValueChange={(e) => onUpdateLine(index, 'descuento', e.value)}
                        className="w-full"
                        inputClassName="p-inputtext-sm text-right"
                        min={0}
                        max={100}
                        mode="decimal"
                        locale="es-CL"
                        minFractionDigits={3}
                        maxFractionDigits={3}
                        step={0.001}
                        suffix=" %"
                        disabled={confirming}
                    />
                </div>
                <div className="flex justify-content-between">
                    <span className="text-600 text-sm">Total</span>
                    <span className="text-900">{(rowData.total ?? 0).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</span>
                </div>
            </div>
        </div>
    );

    return (
        <div className="grid">
            <div className={`col-12 ${(confirming || interfaz === 'MAYORISTA' || isDinar) ? 'md:col-12' : 'md:col-9'}`}>
                {isMobile ? (
                    <div className="flex flex-column">
                        {Array.isArray(detalles) && detalles.length > 0 ? detalles.map((row, idx) => (
                            <MobileRow key={row.id ?? idx} rowData={row} index={idx} />
                        )) : (
                            <div className="surface-card border-1 surface-border border-round p-3 text-center text-600">Agregue productos para ver la cotización</div>
                        )}
                    </div>
                ) : (
                <DataTable
                    value={detalles}
                    tableStyle={isMobile ? null : { minWidth: "50rem"}}
                    size="small"
                    className="p-datatable-sm datatable-responsive border border-1 border-solid border-gray-300"
                    header={<div className="flex justify-content-end text-sm text-500">Productos: {Array.isArray(detalles) ? detalles.length : 0}</div>}
                    globalFilterFields={["cliente.razonSocial"]}
                    stripedRows
                    rowHover
                    showGridlines
                    removableSort
                    resizableColumns
                    columnResizeMode="fit"
                    reorderableColumns
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                    currentPageReportTemplate="{first} - {last} de {totalRecords}"
                    scrollHeight={isMobile ? null : "35vh"}
                    style={{ minHeight: '35vh' }}
                    scrollable={!isMobile}
                    emptyMessage={<div className="p-4 text-center text-600">Agregue productos para armar el detalle</div>}
                >
                    
                    <Column
                        columnKey="remove"
                        header="#"
                        body={(rowData, options) => (
                            <Button
                                icon="pi pi-trash"
                                className="p-button-text p-button-danger p-button-sm"
                                onClick={() => {
                                    const confirmado = window.confirm('¿Está seguro de que desea eliminar este producto?');
                                    if (!confirmado) return;
                                    onRemoveLine(options.rowIndex);
                                }}
                            />
                        )}
                        headerClassName="border-right-1 surface-border border-bottom-0"
                        style={{ width: isMobile ? '3%' : '3%' }}
                    />
                    
                    {isDinar && (
                        <Column
                            columnKey="cajaCompleta"
                            header="Caja Completa"
                            style={{ width: isMobile ? '7%' : '7%' }}
                            body={(rowData, options) => (
                                <input
                                    type="checkbox"
                                    checked={rowData.cajaCompleta || false}
                                    onChange={(e) => onUpdateLine(options.rowIndex, 'cajaCompleta', e.target.checked)}
                                    disabled={confirming && !edit}
                                />
                            )}
                            headerClassName="border-right-1 surface-border border-bottom-0"
                        />
                    )}

                    <Column
                        columnKey="cantidad"
                        header="Cantidad"
                        style={{ width: isMobile ? '7%' : '7%' }}
                        body={(rowData) => (
                            <InputNumber
                                value={rowData.cantidad}
                                onValueChange={(e) => onChangeCantidad(e.value ?? 0, rowData.id)}
                                inputClassName="p-inputtext-sm text-center"
                                min={0}
                                step={1}
                                minFractionDigits={0}
                                maxFractionDigits={0}
                                placeholder="0"
                                disabled={confirming && !edit}
                                showButtons={!isMobile}
                            />
                        )}
                        headerClassName="border-right-1 surface-border border-bottom-0"
                    />
                    {((!isMobile && confirming) || interfaz === 'MAYORISTA') && (
                        <Column
                            columnKey="stock"
                            header="Stock"
                            style={{ width: '5%' }}
                            body={(rowData) => Math.round(rowData.stock ?? 0)}
                            className="text-center"
                            headerClassName="border-right-1 surface-border border-bottom-0"
                        />
                    )} 
                    <Column
                        columnKey="referencia"
                        field="referencia"
                        header="Artículo"
                        style={{ width: '10%' }}
                        sortable
                        headerClassName="border-right-1 surface-border border-bottom-0"
                    />
                    {((!isMobile && confirming) || interfaz === 'MAYORISTA') && (
                        <Column
                            columnKey="centro"
                            header="Centro"
                            style={{ width: '10%' }}
                            body={(rowData, options) => (
                                <Dropdown
                                    value={rowData.centro}
                                    options={almacenes || []}
                                    optionLabel="sucursal"
                                    optionValue="almacen"
                                    onChange={(e) => onUpdateLine(options.rowIndex, 'centro', e.value)}
                                    className="w-full p-inputtext-sm"
                                    placeholder="Seleccione centro"
                                />
                            )}
                            headerClassName="border-right-1 surface-border border-bottom-0"
                        />
                    )}
                    <Column
                        columnKey="descripcion"
                        field="descripcion"
                        header="Descripción"
                        style={{ width: '25%' }}
                        sortable

                    />
                    {isSack && (
                    <Column
                        columnKey="flete"
                        field="flete"
                        body={(rowData) => (
                            <div className="text-center">
                                {rowData.flete != null && Number(rowData.flete) === 0 ? (
                                    <Button
                                        icon="pi pi-exclamation-triangle"
                                        className="p-button-text p-button-warning p-button-rounded p-button-sm"
                                        tooltip="producto no posee valor de flete en la ubicacion de destino desde el centro seleccionado"
                                        tooltipOptions={{ position: 'top' }}
                                    />
                                ) : ""}
                            </div>
                        )}
                        style={{ width: '2%' }}
                    />)}

                    {!isMobile && (
                        <Column
                            columnKey="um"
                            field="um"
                            header="UM"
                            style={{ width: '5%' }}
                            headerClassName="border-right-1 surface-border border-bottom-0"
                        />
                    )}
                    {!isMobile && (
                        <Column
                            columnKey="precio_lista"
                            header="Precio Lista"
                            style={{ width: '10%' }}
                            field="precio_lista"
                            sortable
                            headerClassName="border-right-1 surface-border border-bottom-0"
                        />
                    )}
                    <Column
                        columnKey="precio"
                        header="Precio"
                        style={{ width: '10%' }}
                        field="precio"
                        body={(rowData, options) => (
                            <InputNumber
                                value={rowData.precio}
                                onValueChange={(e) => onUpdateLine(options.rowIndex, 'precio', e.value)}
                                className="w-full"
                                inputClassName="p-inputtext-sm text-right"
                                min={0}
                                locale="es-CL"
                                useGrouping={false}
                                disabled={confirming && !edit}
                            />
                        )}
                        sortable
                        headerClassName="border-right-1 surface-border border-bottom-0"
                    />
                    <Column
                        columnKey="descuento"
                        header="Desc"
                        style={{ width: '7%' }}
                        body={(rowData, options) => (
                            <InputNumber
                                value={rowData.descuento}
                                onValueChange={(e) => onUpdateLine(options.rowIndex, 'descuento', e.value)}
                                className="w-full"
                                inputClassName="p-inputtext-sm text-right"
                                min={0}
                                max={100}
                                mode="decimal"
                                locale="es-CL"
                                minFractionDigits={3}
                                maxFractionDigits={3}
                                step={0.001}
                                suffix=" %"
                                disabled={confirming && !edit}
                            />
                        )}
                        sortable
                        headerClassName="border-right-1 surface-border border-bottom-0"
                    />
                    <Column
                        columnKey="total"
                        header="Total"
                        style={{ width: '8%' }}
                        body={(rowData) => (rowData.total ?? 0).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}
                        sortable
                    />
                </DataTable>
                )}
            </div>

            {interfaz !== 'MAYORISTA' && !confirming && !edit && !isDinar && ( 
                <>
                    {/* TABLERO DE PRODUCTOS RELACIONADOS */}
                    <div className="col-12 md:col-3">
                        <div className="flex flex-column gap-2 h-full">
                            <Dropdown 
                                id="proyecto" 
                                value={proyectoSeleccionado} 
                                options={proyectos || []} 
                                onChange={handleProyectoChange} 
                                optionLabel="descripcion" 
                                optionValue="id" 
                                placeholder="Seleccione un proyecto" 
                                className="p-inputtext-sm" 
                                size="small" 
                            />
                            <DataTable 
                                value={relacionados} 
                                size="small" 
                                className="p-datatable-sm border-1 surface-border border-round flex-1 datatable-responsive" 
                                stripedRows
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                                scrollHeight={isMobile ? null : "30vh"}
                                style={{ minHeight: '30vh' }}
                                scrollable={!isMobile}
                                emptyMessage="No hay productos relacionados"
                            >
                                <Column field="codigo" header="Código" sortable body={(rowData) => (
                                    <span className="text-primary cursor-pointer" onClick={() => addRelacionado(rowData.codigo)}>
                                        {rowData.codigo}
                                    </span>
                                )} 
                                    headerClassName="border-right-1 surface-border border-bottom-0"
                                />
                                <Column field="descripcion" header="Descripción" sortable/>
                            </DataTable>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default TableDetalleCotizacion;
